module.exports = __webpack_public_path__ + "static/media/call-auth-pre.97516c46.png";